// extracted by mini-css-extract-plugin
export default {"footer_last_row_items":"FooterItems2_footer_last_row_items__gpYKh"};